import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

// Element UI
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale })

// Axios
import axios from 'axios'
axios.defaults.baseURL = 'https://' + process.env.VUE_APP_API_URL
console.log("axios", axios.defaults.baseURL)

// Moment
import moment from 'moment'
moment.defaultFormat = "L LTS"
import VueMoment from 'vue-moment'
Vue.use(VueMoment, { moment })

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Monaco (theme configuration)
import drhttpMonacoTheme from "@/assets/styles/drhttp.monaco.js";
const monaco = require("monaco-editor")
monaco.editor.defineTheme('drhttp', drhttpMonacoTheme);
monaco.editor.setTheme('drhttp')    // You need to specify theme of MonacoEditors anyway

// Our app
import App from '@/App.vue'
import store from '@/store/index.js'
import router from '@/router.js'

Vue.config.productionTip = false

// Matomo (analytics)
import VueMatomo from 'vue-matomo'
if (process.env.VUE_APP_ANALYTICS_URL) {
  Vue.use(VueMatomo, {
    host: process.env.VUE_APP_ANALYTICS_URL,
    siteId: 1,
    router: router,
    requireConsent: false,
    //disableCookies: false,
    enableHeartBeatTimer: true,
    //debug: false,
  });
}

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
